import type { TabsProps } from '@mui/material/Tabs'

/**
 * Default MUI Tabs props for dense horizontal tab strips (MainMenu content, company flows).
 * Keeps labels readable on narrow viewports via horizontal scroll instead of compression.
 */
export const SEVV_SCROLLABLE_TABS_PROPS: Pick<
  TabsProps,
  'variant' | 'scrollButtons' | 'allowScrollButtonsMobile'
> = {
  variant: 'scrollable',
  scrollButtons: 'auto',
  allowScrollButtonsMobile: true,
}
